import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Drawer, List, ListItem } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DiscountIcon from "@mui/icons-material/Discount";
import DocumentIcon from "@mui/icons-material/DocumentScanner";
import PricingIcon from "@mui/icons-material/Payment";
import EarningsIcon from "@mui/icons-material/Payments";
import SurgeEventsIcon from "@mui/icons-material/Event";
import ReferralIcon from "@mui/icons-material/LocalOffer";
import ReferralTrackIcon from "@mui/icons-material/Timeline";
import MessageOutlined from "@mui/icons-material/MessageOutlined";
import Person2Outlined from "@mui/icons-material/Person2Outlined";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import GroupIcon from "@mui/icons-material/Group";
import SettingsIcon from "@mui/icons-material/Settings";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import MapIcon from "@mui/icons-material/Map";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import Logo from "../assets/images/logo.png";
import { jwtDecode } from "jwt-decode";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "start",
  flexDirection: "row",
}));

const drawerHeader: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  margin: "5px 10px 20px 10px",
  padding: "5px",
  backgroundColor: "#d3d3d3",
};

const list: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  height: "100vh",
};

const listItem: React.CSSProperties = {
  cursor: "pointer",
  color: "#000000",
};

const drawerStyle: React.CSSProperties = {
  width: "20%",
  backgroundColor: "#FFFFFF",
  height: "100vh",
  borderRight: "none",
};

const drawerStyleResponsive: React.CSSProperties = {
  width: "80%",
  backgroundColor: "#F7FAFC",
  height: "100vh",
  borderRight: "none",
};

const logoutButtonStyleResponsive: React.CSSProperties = {
  fontSize: 16,
  color: "#000000",
  marginLeft: "10%",
  marginBottom: 25,
  display: "flex",
  justifyContent: "start",
  cursor: "pointer",
  alignItems: "center",
};

const adminTabList = [
  {
    id: 0,
    route: "",
    title: "Dashboard",
    icon: <DashboardIcon />,
    icon2: <DashboardIcon />,
  },
  {
    id: 1,
    route: "rides",
    title: "Rides Management",
    icon: <DirectionsCarIcon />,
    icon2: <DirectionsCarIcon />,
  },
  {
    id: 2,
    route: "discounts",
    title: "Discounts",
    icon: <DiscountIcon />,
    icon2: <DiscountIcon />,
  },
  {
    id: 3,
    route: "referral-plans",
    title: "Referral Plans",
    icon: <ReferralIcon />,
    icon2: <ReferralIcon />,
  },
  {
    id: 4,
    route: "referral-tracking",
    title: "Referral Tracking",
    icon: <ReferralTrackIcon />,
    icon2: <ReferralTrackIcon />,
  },
  {
    id: 5,
    route: "driver-documentation",
    title: "Driver Documentation",
    icon: <DocumentIcon />,
    icon2: <DocumentIcon />,
  },
  {
    id: 6,
    route: "pricing",
    title: "Pricing",
    icon: <PricingIcon />,
    icon2: <PricingIcon />,
  },
  {
    id: 7,
    route: "helper-pricing",
    title: "Helper Pricing",
    icon: <PricingIcon />,
    icon2: <PricingIcon />,
  },
  {
    id: 8,
    route: "surge-events",
    title: "Surge Events",
    icon: <SurgeEventsIcon />,
    icon2: <SurgeEventsIcon />,
  },
  {
    id: 9,
    route: "earnings-and-management",
    title: "Earnings & Management",
    icon: <EarningsIcon />,
    icon2: <EarningsIcon />,
  },
  {
    id: 10,
    route: "delivery-earnings-and-management",
    title: "Delivery Earnings & Management",
    icon: <EarningsIcon />,
    icon2: <EarningsIcon />,
  },
  {
    id: 11,
    route: "notifications",
    title: "Notification Templates",
    icon: <MessageOutlined />,
    icon2: <MessageOutlined />,
  },
  {
    id: 12,
    route: "admins",
    title: "Manage Admins",
    icon: <Person2Outlined />,
    icon2: <Person2Outlined />,
  },
  {
    id: 13,
    route: "partners",
    title: "Partners",
    icon: <Person2Outlined />,
    icon2: <Person2Outlined />,
  },
  {
    id: 16,
    route: "offer-types",
    title: "Offer Types",
    icon: <PricingIcon />,
    icon2: <PricingIcon />,
  },
  {
    id: 17,
    route: "app-versions",
    title: "App Versions",
    icon: <PhoneAndroidIcon />,
    icon2: <PhoneAndroidIcon />,
  },
  {
    id: 14,
    route: "users",
    title: "Users",
    icon: <Person2Outlined />,
    icon2: <Person2Outlined />,
  },
  {
    id: 15,
    route: "websocket-ui",
    title: "Web Socket UI",
    icon: <DashboardIcon />,
    icon2: <DashboardIcon />,
  },
];

const backOfficeTabList = [
  // {
  //   id: 0,
  //   route: "",
  //   title: "Dashboard",
  //   icon: <DashboardIcon />,
  //   icon2: <DashboardIcon />,
  // },
  {
    id: 0,
    route: "rides",
    title: "Rides Management",
    icon: <DirectionsCarIcon />,
    icon2: <DirectionsCarIcon />,
  },
  {
    id: 1,
    route: "discounts",
    title: "Discounts",
    icon: <DiscountIcon />,
    icon2: <DiscountIcon />,
  },
  {
    id: 2,
    route: "referral-plans",
    title: "Referral Plans",
    icon: <ReferralIcon />,
    icon2: <ReferralIcon />,
  },
  {
    id: 3,
    route: "referral-tracking",
    title: "Referral Tracking",
    icon: <ReferralTrackIcon />,
    icon2: <ReferralTrackIcon />,
  },
  {
    id: 4,
    route: "driver-documentation",
    title: "Driver Documentation",
    icon: <DocumentIcon />,
    icon2: <DocumentIcon />,
  },
  {
    id: 5,
    route: "surge-events",
    title: "Surge Events",
    icon: <SurgeEventsIcon />,
    icon2: <SurgeEventsIcon />,
  },
  {
    id: 6,
    route: "notifications",
    title: "Notification Templates",
    icon: <MessageOutlined />,
    icon2: <MessageOutlined />,
  },
  {
    id: 7,
    route: "users",
    title: "Users",
    icon: <Person2Outlined />,
    icon2: <Person2Outlined />,
  },
  {
    id: 8,
    route: "websocket-ui",
    title: "Web Socket UI",
    icon: <DashboardIcon />,
    icon2: <DashboardIcon />,
  },
];

const agentTabList = [
  // {
  //   id: 0,
  //   route: "",
  //   title: "Dashboard",
  //   icon: <DashboardIcon />,
  //   icon2: <DashboardIcon />,
  // },
  // {
  //   id: 0,
  //   route: "driver-documentation",
  //   title: "Driver Documentation",
  //   icon: <DocumentIcon />,
  //   icon2: <DocumentIcon />,
  // },
  {
    id: 1,
    route: "websocket-ui",
    title: "Web Socket UI",
    icon: <DashboardIcon />,
    icon2: <DashboardIcon />,
  },
  {
    id: 2,
    route: "rides",
    title: "Rides Management",
    icon: <DirectionsCarIcon />,
    icon2: <DirectionsCarIcon />,
  },
  {
    id: 3,
    route: "users",
    title: "Users",
    icon: <Person2Outlined />,
    icon2: <Person2Outlined />,
  },
];

// Helper function to get partner tab list based on permissions
const getPartnerTabList = (permissions?: any): any[] => {
  const tabs = [];
  
  // Agents - only for partner role
  tabs.push({
    id: 0,
    route: "partner-dashboard/agents",
    title: "Agents",
    icon: <GroupIcon />,
    icon2: <GroupIcon />,
    show: true, // Will be filtered based on role
  });
  
  // Cars - for both partner and partner-agent
  tabs.push({
    id: 1,
    route: "partner-dashboard/cars",
    title: "Cars",
    icon: <DirectionsCarIcon />,
    icon2: <DirectionsCarIcon />,
    show: !permissions || permissions.canViewCars !== false,
  });
  
  // Drivers - for both partner and partner-agent
  tabs.push({
    id: 2,
    route: "partner-dashboard/drivers",
    title: "Drivers",
    icon: <Person2Outlined />,
    icon2: <Person2Outlined />,
    show: !permissions || permissions.canViewDrivers !== false,
  });
  
  // Owners - for both partner and partner-agent
  tabs.push({
    id: 3,
    route: "partner-dashboard/owners",
    title: "Owners",
    icon: <AccountTreeIcon />,
    icon2: <AccountTreeIcon />,
    show: !permissions || permissions.canViewOwners !== false,
  });
  
  // Transactions (formerly Rides) - for both partner and partner-agent (if transactions permission is allowed)
  tabs.push({
    id: 4,
    route: "partner-dashboard/rides",
    title: "Transactions",
    icon: <EarningsIcon />,
    icon2: <EarningsIcon />,
    show: !permissions || permissions.canViewTransactions !== false, // Use transactions permission
  });
  
  // Map - for both partner and partner-agent
  tabs.push({
    id: 6,
    route: "partner-dashboard/map",
    title: "Map",
    icon: <MapIcon />,
    icon2: <MapIcon />,
    show: !permissions || permissions.canViewMap !== false,
  });
  
  // Settings - only for partner role
  tabs.push({
    id: 7,
    route: "partner-dashboard/settings",
    title: "Settings",
    icon: <SettingsIcon />,
    icon2: <SettingsIcon />,
    show: true, // Will be filtered based on role
  });
  
  return tabs;
};

const SidePanel = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const [tabList, setTabList] = useState<any>(null);
  const token = localStorage.getItem("token");
  let location = useLocation();
  const navigate = useNavigate();
  const urlHash = location.pathname === "/" ? "/" : location.pathname;

  const isMobile = useMediaQuery("(max-width: 600px)");

  useEffect(() => {
    if (token) {
      const decoded: any = jwtDecode(token);
      if (decoded.role === "backoffice") {
        setTabList(backOfficeTabList);
      } else if (decoded.role === "agent") {
        setTabList(agentTabList);
      } else if (decoded.role === "partner") {
        // For partner, show all tabs except filter out based on show flag
        const allTabs = getPartnerTabList();
        // Filter: show Agents and Settings for partner, all others are shown by default
        const filteredTabs = allTabs.filter((tab) => {
          if (tab.route === "partner-dashboard/agents" || tab.route === "partner-dashboard/settings") {
            return true; // Always show for partner
          }
          return tab.show; // Show based on default permissions
        });
        setTabList(filteredTabs);
      } else if (decoded.role === "partner-agent") {
        // For partner-agent, filter based on permissions
        const permissions = decoded.permissions || {};
        const allTabs = getPartnerTabList(permissions);
        // Filter: hide Agents and Settings, show others based on permissions
        const filteredTabs = allTabs.filter((tab) => {
          if (tab.route === "partner-dashboard/agents" || tab.route === "partner-dashboard/settings") {
            return false; // Never show for partner-agent
          }
          return tab.show; // Show based on permissions
        });
        setTabList(filteredTabs);
      } else {
        setTabList(adminTabList);
      }
    }
  }, [token]);

  const handleCloseSidebar = () => {
    onClose();
  };

  return (
    <div>
      <Drawer
        variant="permanent"
        anchor="left"
        open={isOpen}
        PaperProps={{
          style: isMobile ? drawerStyleResponsive : drawerStyle,
        }}
      >
        <DrawerHeader style={drawerHeader}>
          <img src={Logo} alt="logo" width={200} height={50} />
        </DrawerHeader>

        <List style={list}>
          {tabList?.map((data: any, index: number) => (
            <div
              key={index}
              style={{
                background: urlHash === `/${data.route}` ? "#1677BC" : "#FFFFFF",
                margin: "3%",
                borderRadius: "5px",
              }}
            >
              <Link
                style={{ textDecoration: "none" }}
                to={{
                  pathname: `/${data.route}`,
                }}
              >
                <ListItem style={listItem}>
                  <span
                    style={{
                      fontSize: 16,
                      color: urlHash === `/${data.route}` ? "#FFFFFF" : "#000000",
                      marginLeft: 8,
                      marginTop: 4,
                      marginBottom: 4,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {urlHash === `/${data.route}` ? data.icon : data.icon} &nbsp; &nbsp;
                    {data.title}
                  </span>
                </ListItem>
              </Link>
            </div>
          ))}
        </List>
        {isMobile ? (
          <Box>
            <span style={logoutButtonStyleResponsive} onClick={handleCloseSidebar}>
              <CloseIcon /> &nbsp; &nbsp; Close
            </span>
          </Box>
        ) : null}
      </Drawer>
    </div>
  );
};

export default SidePanel;
